<template>
    <div class="contanierBox">
        <div class="header">
            <div class="routeTit" v-if="$route.meta.title!=='首页'">
                <span v-if="$route.meta.title!==''">{{$route.meta.title}}</span>
                <span v-else>{{ newTitle }}</span>
            </div>
            <img v-else class="logo" src="../../assets/img/logo.png">
            <div class="tools">
                <div class="navBtn" @click='expandMenu()'>
                    <img src="../../assets/img/menu.png" v-show="showFlag==false">
                </div>
            </div>
        </div>
        <!-- 占位box -->
        <div class="replaceBox"></div>
        <!-- 下拉菜单 -->
        <div class="dropdownBox" v-show="showFlag === true" @click="closeMenu()">
            <div class="menuList" @click.stop>
                <div class="close_box" @click='closeMenu()'>
                    <img src="../../assets/img/detele.png" class="close_img">
                </div>
                <div class="language_box" v-if="$route.meta.title!='展品详情'">
                    <span :class="languageId===1?'active':''" @click="languageId=1">中文</span>
                    <span :class="languageId===2?'active':''" @click="toEnglishProject()">EN</span>
                </div>
                <div class="item" v-for="i in menuList" :key="i.id" @click="toDetail(i)">
                    <div :class="i.id===menuIndex?'active':''">{{ i.title }}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: '',
    data () {
        return {
            languageId: 1,
            tourFlag: false,
            showFlag: false,
            menuList: [
                {
                    id: 1,
                    type: 'inside',
                    title: '首页',
                    path: '/'
                },
                {
                    id: 2,
                    type: 'inside',
                    title: '关于金沙',
                    path: '/aboutUs'
                },
                {
                    id: 3,
                    type: 'outside',
                    title: '志愿者中心',
                    path: ''
                },
                {
                    id: 4,
                    type: 'outside',
                    title: '会员中心',
                    path: ''
                },
                {
                    id: 5,
                    type: 'outside',
                    title: '团体预约',
                    path: ''
                },
                {
                    id: 6,
                    type: 'inside',
                    title: '参观指南',
                    path: '/tourGuide'
                },
                {
                    id: 7,
                    type: 'inside',
                    title: '参观导览',
                    path: '/guide'
                }
            ],
            menuIndex: 1,
            curPath: '',
            newTitle: '',
            zyz_url: '', // 志愿者中心
            hyzx_url: '', // 会员中心
            ttyy_url: '' // 团体预约

        }
    },
    created () {
        let vm = this
        if (localStorage.getItem('zyz_url')) {
            vm.zyz_url = localStorage.getItem('zyz_url')
        }
        if (localStorage.getItem('hyzx_url')) {
            vm.hyzx_url = localStorage.getItem('hyzx_url')
        }
        if (localStorage.getItem('ttyy_url')) {
            vm.ttyy_url = localStorage.getItem('ttyy_url')
        }
    },
    methods: {
        /**
         * *
         */
        toEnglishProject () {
            // this.languageId = 2
            window.open(`${this.$root.baseUrl}/mobile_en/#/`)
        },
        /**
         * * 特定返回首页
         */
        toBackHome () {
            // console.log('开始特定返回首页')
            this.$router.push({path: '/'})
        },
        /**
         * * 特定返回 [暂时弃用]
         */
        toBackGuide () {
            // console.log('开始特定返回')
            this.$router.push({path: '/tourGuide', query: {cate: 2}})
        },
        /**
         * 返回一层
         */
        toBack () {
            this.$router.go(-1)
        },
        /**
         * 展开下拉菜单
         */
        expandMenu () {
            this.showFlag = !this.showFlag
        },
        /**
         * 关闭下拉菜单
         */
        closeMenu () {
            this.showFlag = false
        },
        /**
         * 选择菜单
         */
        toDetail (e) {
            let vm = this
            vm.menuIndex = e.id
            if (e.path !== '') {
                if (e.path === 'tourGuide') {
                    vm.tourFlag = true
                }
                vm.$router.push(e.path)
                vm.tourFlag = false
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
                setTimeout(() => {
                    vm.showFlag = false
                }, 300)
            } else {
                // 路由为空的话证明是外部链接
                if (e.id === 3) {
                    //* 志愿者中心
                    console.log('志愿者中心====', vm.zyz_url)
                    if (vm.zyz_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.zyz_url
                    }
                } else if (e.id === 4) {
                    //* 会员中心
                    if (vm.hyzx_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.hyzx_url
                    }
                } else if (e.id === 5) {
                    //* 团体预约
                    if (vm.ttyy_url === '') {
                        vm.$toast.fail('建设中')
                    } else {
                        window.location.href = vm.ttyy_url
                    }
                } else {
                    vm.$toast('路由错误')
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .dropdownBox {
        width: 100%;
        min-height: 100vh;
        background-color: rgba(0,0,0,.5);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        color: $base-color;
        .menuList {
            width: 428px;
            background-color: #1F1108;
            // color: #ffffff;
            padding-bottom: 20px;
            margin-left: auto;
            div {
                width: 428px;
                margin: 0 auto;
                padding: 18px 0;
                text-align: center;
                font-size: 30px;
                line-height: 30px;
                letter-spacing: 1px;
                border-bottom: 1px solid rgba(205,179,120,.5);
            }
            div:last-of-type {
                border-bottom: none;
            }
            .close_box {
                height: 70px;
                position: relative;
                border-bottom: none;
                .close_img {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: 20px;
                    right: 30px;
                }
            }
            .language_box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 37px 30px;
                span {
                    width: 164px;
                    height: 64px;
                    line-height: 64px;
                    background: rgba(255,255,255,0.00);
                    border: 2px solid #e0b557;
                    border-radius: 5px;
                }
                .active {
                    background: rgba(218,184,102,0.26);
                }
            }
        }
    }
    .replaceBox {
        height: 100px;
    }
    .header {
        color: $base-color;
        width: 100%;
        height: 100px;
        background: #1F1108;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .logo{
            width: 245px;
        }
        .routeTit{
            height: 34px;
            font-size: 48px;
            font-weight: 500;
            letter-spacing: 2px;
            color: $base-color;
            line-height: 34px;
            display: flex;
            flex-direction: row;
            .backIcon {
                width: 32px;
                height: 32px;
                margin-right: 26px;
            }
        }
        .tools {
            width: 138px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .search {
                width: 32px;
                height: 32px;
                img {
                    width: 32px;
                    height: 32px;
                    display: block;
                }
            }
            .line {
                display: inline-block;
                width: 1px;
                height: 32px;
                background: #ffffff;
                opacity: .6;
                margin: 0 36px;
            }
            .navBtn {
                width: 40px;
                height: 40px;
                margin-left: auto;
                img {
                    width: 40px;
                    height: 40px;
                    display: block;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue